import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
import LoadingOverlay from 'framework-asset-preview-lib/internal/shared/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncWhatsAppTemplatePreviewPopover = Loadable({
  loader: () => import( /* webpackChunkName: "whatsapp-template-preview-popover" */'./Preview/WhatsAppTemplatePreviewPopover').then(mod => mod.default).catch(AsyncComponentErrorHandler('whatsapp-template-preview-popover')),
  LoadingComponent: () => /*#__PURE__*/_jsx(LoadingOverlay, {
    previewType: "popover"
  })
});
export default AsyncWhatsAppTemplatePreviewPopover;